import { useEffect } from 'react'

import { getPageSource, track, trackExperimentViewed } from '@mc/track-event'

import { CONCIERGE_EXPERIENCE_FLAG_NAME } from './constants'

export const useTrackConciergeExperienceExperiment = () => {
  useEffect(() => {
    trackExperimentViewed(CONCIERGE_EXPERIENCE_FLAG_NAME)
  }, [])
}

export const trackConciergeClicked = ({
  level = 'primary',
  action,
}: {
  level: 'primary' | 'secondary'
  action: string
}) => {
  track('Concierge Clicked', {
    level,
    action,
    page_source: getPageSource(),
  })
}

export const trackConciergeViewedorDismissed = ({
  show,
  manuallyDismissed,
}: {
  show: boolean
  manuallyDismissed: boolean
}) => {
  if (show) {
    track('Concierge Viewed', {
      page_source: getPageSource(),
      user_clicked: manuallyDismissed,
    })
  } else {
    track('Concierge Dismissed', {
      page_source: getPageSource(),
      user_clicked: manuallyDismissed,
    })
  }
}
